import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import cn from 'classnames'

import { useGlobalStore } from 'src/zustand/providers/global-store-provider'
import { useUserSettingsMenu } from 'src/zustand/stores/userSettingsMenu.store'

import { MENU_PARAMS } from './UserSettingsMenu.consts'
import styles from './UserSettingsMenu.module.scss'
import { MenuIcon } from './components'

export const UserSettingsMenu = () => {
  const isActive = useUserSettingsMenu((state) => state.isActive)
  const toggleMenu = useUserSettingsMenu((state) => state.toggleMenu)

  const user = useGlobalStore((state) => state.user)
  const { t } = useTranslation()

  if (isActive) {
    document.body.classList.add(styles.no_scroll)
  } else {
    document.body.classList.remove(styles.no_scroll)
  }

  let nameOfUser = ''
  if (user) {
    nameOfUser = !user.username ? user.first_name + ' ' + user.last_name : user.username
  }

  const userIsPremium = user?.is_premium

  return (
    <div
      className={cn(styles.wrapper, {
        [styles.active]: isActive,
      })}
    >
      <div
        className={cn(styles.menu, {
          [styles.active]: isActive,
        })}
      >
        <div className={`${styles.info} ${userIsPremium && styles.premium}`}>
          <div className={styles.avatar}>
            <img src={user?.photo_url} alt="User's avatar" />
          </div>
          <p className={styles.name}>{nameOfUser}</p>
        </div>

        <div className={styles.menu_list}>
          {MENU_PARAMS.map((item) => (
            <Link to={item.path} key={item.path} className={styles['menu_list-item']}>
              <MenuIcon name={item.icon} />
              <p>{t(item.title)}</p>
            </Link>
          ))}
        </div>
      </div>

      <div
        onClick={toggleMenu}
        className={cn(styles.clickable, {
          [styles.active]: isActive,
        })}
      />
    </div>
  )
}
